import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { TFunction } from 'i18next';
import { HAS_SMOKING_PLACES_OPTIONS, IS_SMOKING_ALLOWED_OPTIONS } from '../consts';
import { TEST_IDS } from '../testIds';

const useAnotherDataFieldsConfig = ({
    t,
    anotherDataFormData,
    handleBlurValidation
}: {
    t: TFunction;
    anotherDataFormData: any;
    handleBlurValidation: any;
}) => {
    const [anotherDataFieldsConfig, setAnotherDataFieldsConfig] = useState<FieldConfig[]>([]);

    useEffect(() => {
        const employeeQuanityFieldsConfig: FieldConfig[] = [
            {
                type: 'autocomplete-default',
                label: t('anotherDataForm.inputs.hasSmokinPlaces'),
                name: 'hasSmokinPlaces',
                required: true,
                value: anotherDataFormData.hasSmokinPlaces,
                disabled: false,
                helperText: t('anotherDataForm.inputs.hasSmokinPlaces') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12, md: 6 },
                options: HAS_SMOKING_PLACES_OPTIONS,
                testID: TEST_IDS.anotherDataFields.hasSmokinPlaces,
                validations: [{ name: 'required' }, { name: 'maxLength', param: 14 }]
            },
            {
                type: 'autocomplete-default',
                label: t('anotherDataForm.inputs.isSmokingAllowed'),
                name: 'isSmokingAllowed',
                required: true,
                value: anotherDataFormData.isSmokingAllowed,
                disabled: false,
                helperText: t('anotherDataForm.inputs.isSmokingAllowed') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12, md: 6 },
                options: IS_SMOKING_ALLOWED_OPTIONS,
                testID: TEST_IDS.anotherDataFields.isSmokingAllowed,
                validations: [{ name: 'required' }, { name: 'maxLength', param: 14 }]
            },
            {
                type: 'textarea',
                label: t('anotherDataForm.inputs.observations'),
                name: 'observations',
                value: anotherDataFormData.observations,
                maxLength: 400,
                helperText: t('anotherDataForm.inputs.observations') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                testID: TEST_IDS.anotherDataFields.observations,
                validations: [{ name: 'maxLength', param: 400 }]
            }
        ];
        setAnotherDataFieldsConfig(employeeQuanityFieldsConfig);
    }, []);

    return { anotherDataFieldsConfig };
};

export default useAnotherDataFieldsConfig;
